import React from "react";

const StudentScreen = React.createContext<any>({});

export default StudentScreen;
